/**
 * CostEstimator.schema.js
 *
 * Schema definition for the Cost Estimator tool.
 * Defines fields, steps, and validation rules.
 */

const CostEstimatorSchema = {
  steps: [
    {
      id: "projectDetails",
      title: "Project Details",
      fields: ["zip", "homeSize", "projectScope", "materialQuality"],
    },
  ],

  fields: {
    zip: {
      type: "text",
      label: "ZIP Code",
      placeholder: "e.g. 90210",
      required: true,
      validation: {
        pattern: /^\d{5}$/,
        message: "Please enter a valid 5-digit ZIP code.",
      },
    },

    homeSize: {
      type: "select",
      label: "Home Size",
      required: true,
    },

    projectScope: {
      type: "select",
      label: "Project Scope",
      required: true,
    },

    materialQuality: {
      type: "select",
      label: "Material Quality",
      required: true,
    },
  },

  /**
   * Output schema (placeholder for future logic)
   */
  output: {
    estimateRange: {
      min: "number",
      max: "number",
    },
    confidence: {
      type: "string",
      enum: ["low", "medium", "high"],
    },
  },
};

export default CostEstimatorSchema;
